export default __webpack_public_path__ + "static/HalvarBreit-Blk-ba578dc35ab8252158a3fa5fa6fd0e24.woff";